import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Home as HomeIcon, Sparkles, ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RoomHappinessCard({ onOpen }) {
  const [rooms, setRooms] = useState(null);

  const fetchRooms = async () => {
    try {
      const { data } = await axios.get(`${API}/rooms`, { withCredentials: true });
      setRooms(data.rooms || []);
    } catch {
      setRooms([]);
    }
  };

  useEffect(() => {
    fetchRooms();
    const handler = () => fetchRooms();
    window.addEventListener('rooms:updated', handler);
    return () => window.removeEventListener('rooms:updated', handler);
  }, []);

  if (rooms === null || rooms.length === 0) return null;

  const total = rooms.length;
  const fullyDone = rooms.filter((r) => {
    const n = r.analysis?.suggestions?.length || 0;
    const d = (r.completed_suggestions || []).length;
    return n > 0 && d === n;
  }).length;

  let sumPct = 0;
  let cnt = 0;
  rooms.forEach((r) => {
    const n = r.analysis?.suggestions?.length || 0;
    if (n > 0) {
      const d = (r.completed_suggestions || []).length;
      sumPct += (d / n) * 100;
      cnt += 1;
    }
  });
  const avg = cnt ? Math.round(sumPct / cnt) : 0;

  const vibeScores = rooms.map((r) => Number(r.analysis?.vibe_score || 0)).filter(Boolean);
  const avgVibe = vibeScores.length
    ? Math.round((vibeScores.reduce((a, b) => a + b, 0) / vibeScores.length) * 10) / 10
    : null;

  const allDone = fullyDone === total && total > 0;
  const bgGradient = allDone
    ? 'from-[#B9FBC0] via-[#FFE8F0] to-[#C8B6FF]'
    : avg >= 50
    ? 'from-[#FDF0D5] via-[#FFE8F0] to-[#A2D2FF]'
    : 'from-[#FFE8F0] via-[#FDF0D5] to-[#A2D2FF]';

  return (
    <button
      onClick={onOpen}
      className={`neo-card w-full p-4 mb-4 text-left bg-gradient-to-br ${bgGradient} hover:translate-y-[-1px] transition`}
      data-testid="room-happiness-card"
    >
      <div className="flex items-start gap-3">
        <div className="w-12 h-12 rounded-2xl bg-white border-[3px] border-black flex items-center justify-center shrink-0 shadow-[3px_3px_0_#000]">
          <HomeIcon className="w-6 h-6" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-bold text-base flex items-center gap-1.5">
              Rumslycka <Sparkles className="w-4 h-4" />
            </h3>
            <ChevronRight className="w-5 h-5 shrink-0" />
          </div>
          <p className="text-xs text-black/75 mt-0.5">
            {allDone ? (
              <><span className="font-bold">Alla dina rum är 100% organiserade!</span> Din kompis jublar 🎉</>
            ) : (
              <>
                <span className="font-bold">{fullyDone}</span> av <span className="font-bold">{total}</span> rum 100% klara ·{' '}
                <span className="font-bold">{avg}%</span> snitt
                {avgVibe !== null && (
                  <> · Vibe <span className="font-bold">{avgVibe}/10</span></>
                )}
              </>
            )}
          </p>
          {/* mini progress */}
          <div className="mt-2 h-2 w-full border-[2px] border-black rounded-full overflow-hidden bg-white">
            <div
              className="h-full transition-all duration-500"
              style={{
                width: `${avg}%`,
                background: avg === 100 ? 'linear-gradient(90deg,#B9FBC0,#C8B6FF,#FFC8DD)' : '#B9FBC0',
              }}
            />
          </div>
        </div>
      </div>
    </button>
  );
}
